import React, { useState, useEffect, useRef } from "react";
import { db } from "../../firebase";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  doc,
  setDoc,
} from "firebase/firestore";
import { useForm } from "react-hook-form";
import PrimaryButton from "../Buttons/PrimaryButton";
import SubmitButton from "../Buttons/SubmitButton";
import { useNavigate } from "react-router-dom";
// import jsPDF from 'jspdf';
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step6 from "./Step6";
import Step6bis from "./Step6bis";
import { useAuth } from "../../context/AuthContext";
import { toast } from "sonner";
// const { toWords } = require('number-to-words');

const MultiStepForm = () => {
  const { user } = useAuth();
  const [step, setStep] = useState(1);
  const [personType, setPersonType] = useState(null); // Gère le type de personne (physique/morale)
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      cylindree: "",
      usage: "",
      duration: "",
      immat: "",
      vehicleType: "",
      fiscalPower: "",
      isInSale: "",
      numberOfCards: "",
      cards: "",
      isDoublePedal: "",
      seats: "",
      tonnage: "",
      realseats: "",
      trailers: "",
      brand: "",
      carColor: "",
      model: "",
      chassisNumber: "",
      manufactureYear: "",
      firstRegistrationYear: "",
      payload: "",
      otherspecial: "",
      document: "",
    },
  });

  const [vehicles, setVehicles] = useState([]);
  const [selectedType, setSelectedType] = useState(""); // Type de véhicule
  const [selectedImmat, setSelectedImmat] = useState(""); // Type de véhicule
  const [selectedUsage, setSelectedUsage] = useState(""); // Usage du véhicule
  const [isInSale, setIsInSale] = useState(""); // Le véhicule est en vente/réparation
  const [selectedCylindree, setSelectedCylindree] = useState(""); // Cylindrée (moto seulement)
  const [selectedDuration, setSelectedDuration] = useState(""); // Durée de la couverture
  const [selectedFiscalPower, setSelectedFiscalPower] = useState(""); // Puissance fiscale (voiture, SUV, bus)
  const [selectedTonnage, setSelectedTonnage] = useState(""); // Tonnage pour camion
  const [selectedSeats, setSelectedSeats] = useState(""); // Nombre de places pour bus
  const [selectedRealSeats, setSelectedRealSeats] = useState(""); // Nombre de places pour bus
  const [isDoublePedal, setIsDoublePedal] = useState("");
  const [selectedTrailers, setSelectedTrailers] = useState(""); // Nombre de remorques pour camion
  const [SelectedCards, setSelectedCards] = useState(""); // Nombre de cartes
  const [selectedRealCardCount, setSelectedRealCardCount] = useState(""); // Nombre de cartes précis
  const navigate = useNavigate();
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [colors, setColors] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  const [docRef, setDocRef] = useState("");
  const [newBrand, setNewBrand] = useState("");
  const [newModel, setNewModel] = useState("");
  const [newColor, setNewColor] = useState("");
  const [brandModels, setBrandModels] = useState({});
  const [otherVehicle, setOtherVehicle] = useState("");
  const firstVehicle = vehicles[0];
  const [signatureUrl, setSignatureURL] = useState("");
  const [signatureImage, setSignatureImage] = useState(null);
  const [isSignatureValid, setIsSignatureValid] = useState(false);
  const [isCardPayment, setIsCardPayment] = useState("");
  const [formdocId, setFormDocId] = useState("");
  const [tarifsBlock, setTarifsBlock] = useState({
    discount: 0,
    totalPrice: 0,
    TVA: 0,
    ARCA: 0,
    finalPrice: 0,
  });

  const insuranceRates = {
    moto: {
      personnel: {
        "0-50": { 30: 53, 90: 43 },
        "51-99": { 30: 60, 90: 50 },
        "100-150": { 30: 69, 90: 57 },
        "151-350": { 30: 79, 90: 65 },
        "350+": { 30: 93, 90: 76 },
      },
      taxi: {
        30: 69,
        90: 57,
      },
      ecolage: {
        "0-50": { 30: 61, 90: 50 },
        "51-99": { 30: 69, 90: 57 },
        "100-150": { 30: 81, 90: 67 },
        "151-350": { 30: 105, 90: 87 },
        "350+": { 30: 139, 90: 114 },
      },
      commerce: {
        1: { 30: 113, 90: 93 },
        2: { 30: 169, 90: 139 },
        3: { 30: 226, 90: 186 },
        4: { 30: 282, 90: 232 },
        more: { 30: 56, 90: 46 },
      },
    },
    voiture: {
      personnel: {
        oui: {
          1: { 30: 828, 90: 682 },
          2: { 30: 1237, 90: 1019 },
          3: { 30: 1655, 90: 1363 },
          4: { 30: 2068, 90: 1703 },
          more: { 30: 414, 90: 341 },
        },
        non: {
          "1-5": { 30: 125, 90: 103 },
          "6-9": { 30: 140, 90: 116 },
          "10-13": { 30: 182, 90: 150 },
          "14-17": { 30: 264, 90: 218 },
          "17+": { 30: 364, 90: 300 },
        },
      },
      transport_commun: {
        oui: {
          1: { 30: 956, 90: 788 },
          2: { 30: 1434, 90: 1181 },
          3: { 30: 1913, 90: 1575 },
          4: { 30: 2390, 90: 1968 },
          more: { 30: 478, 90: 393 },
        },
        non: {
          30: 563,
          90: 463,
        },
      },
      taxi: { 90: 379 },
      ecolage: {
        oui: {
          "1-5": { 30: 170, 90: 140 },
          "6-9": { 30: 207, 90: 171 },
          "10-13": { 30: 303, 90: 250 },
          "14-17": { 30: 353, 90: 291 },
          "17+": { 30: 363, 90: 299 },
        },
        non: {
          "1-5": { 30: 218, 90: 179 },
          "6-9": { 30: 249, 90: 205 },
          "10-13": { 30: 364, 90: 300 },
          "14-17": { 30: 422, 90: 348 },
          "17+": { 30: 435, 90: 358 },
        },
      },
      location: {
        "1-5": { 30: 229, 90: 188 },
        "6-9": { 30: 247, 90: 203 },
        "10-13": { 30: 343, 90: 282 },
        "14-17": { 30: 395, 90: 326 },
        "17+": { 30: 423, 90: 349 },
      },
    },
    suv: {
      personnel: {
        oui: {
          1: { 30: 828, 90: 682 },
          2: { 30: 1237, 90: 1019 },
          3: { 30: 1655, 90: 1363 },
          4: { 30: 2068, 90: 1703 },
          more: { 30: 414, 90: 341 },
        },
        non: {
          "1-5": { 30: 125, 90: 103 },
          "6-9": { 30: 140, 90: 116 },
          "10-13": { 30: 182, 90: 150 },
          "14-17": { 30: 264, 90: 218 },
          "17+": { 30: 364, 90: 300 },
        },
      },
      transport_commun: {
        oui: {
          1: { 30: 956, 90: 788 },
          2: { 30: 1434, 90: 1181 },
          3: { 30: 1913, 90: 1575 },
          4: { 30: 2390, 90: 1968 },
          more: { 30: 478, 90: 393 },
        },
        non: {
          30: 563,
          90: 463,
        },
      },
      taxi: { 90: 379 },
      ecolage: {
        oui: {
          "1-5": { 30: 170, 90: 140 },
          "6-9": { 30: 207, 90: 171 },
          "10-13": { 30: 303, 90: 250 },
          "14-17": { 30: 353, 90: 291 },
          "17+": { 30: 363, 90: 299 },
        },
        non: {
          "1-5": { 30: 218, 90: 179 },
          "6-9": { 30: 249, 90: 205 },
          "10-13": { 30: 410, 90: 337 },
          "14-17": { 30: 422, 90: 348 },
          "17+": { 30: 435, 90: 358 },
        },
      },
      location: {
        "1-5": { 30: 229, 90: 188 },
        "6-9": { 30: 247, 90: 203 },
        "10-13": { 30: 343, 90: 282 },
        "14-17": { 30: 395, 90: 326 },
        "17+": { 30: 423, 90: 349 },
      },
    },
    bus: {
      transport_commun: {
        "0-15": { 30: 563, 90: 463 },
        "16-30": { 30: 654, 90: 538 },
        "31-50": { 30: 961, 90: 791 },
        ">50": { 30: 961, 90: 791 },
      },
      taxi: {
        "5-9": { 90: 455 },
        "10-15": { 90: 581 },
        "16-30": { 90: 708 },
        "31-50": { 90: 917 },
        ">50": { 90: 917 },
      },
    },
    camion: {
      marchandises: {
        oui: {
          1: { 30: 828, 90: 682 },
          2: { 30: 1237, 90: 1019 },
          3: { 30: 1655, 90: 1363 },
          4: { 30: 2068, 90: 1703 },
          more: { 30: 414, 90: 341 },
        },
        non: {
          "0-3.5": { 90: 304 },
          "3.6-8": { 90: 361 },
          "9-15": { 90: 410 },
          ">15": { 90: 457 },
        },
        supplement: {
          "0-3.5": { 90: 167 },
          "3.6-8": { 90: 199 },
          "9-15": { 90: 226 },
          ">15": { 90: 251 },
        },
      },
      marchandises_r: {
        oui: {
          1: { 30: 828, 90: 682 },
          2: { 30: 1237, 90: 1019 },
          3: { 30: 1655, 90: 1363 },
          4: { 30: 2068, 90: 1703 },
          more: { 30: 414, 90: 341 },
        },
        non: {
          "0-3.5": { 90: 328 },
          "3.6-8": { 90: 389 },
          "9-15": { 90: 441 },
          ">15": { 90: 491 },
        },
        supplement: {
          "0-3.5": { 90: 181 },
          "3.6-8": { 90: 214 },
          "9-15": { 90: 243 },
          ">15": { 90: 270 },
        },
      },
      ecolage: {
        oui: {
          "0-3.5": { 30: 365, 90: 300 },
          "3.6-8": { 30: 579, 90: 477 },
          "9-15": { 30: 766, 90: 631 },
          ">15": { 30: 1149, 90: 946 },
        },
        non: {
          "0-3.5": { 30: 438, 90: 361 },
          "3.6-8": { 30: 694, 90: 572 },
          "9-15": { 30: 921, 90: 758 },
          ">15": { 30: 1379, 90: 1135 },
        },
      },
      location: {
        "0-3.5": { 90: 473 },
        "3.6-8": { 90: 592 },
        "9-15": { 90: 706 },
        ">15": { 90: 942 },
        supp: { 90: 424 },
      },
    },
    special: {
      tracteurs: {
        30: 545,
        90: 449,
      },
      excavateurs: {
        30: 630,
        90: 519,
      },
      engins: {
        30: 711,
        90: 585,
      },
      citerne: {
        0: { 90: 627 },
        1: { 90: 678 },
        2: { 90: 848 },
      },
      autres: {
        "1-5": { 30: 155, 90: 127 },
        "6-9": { 30: 170, 90: 140 },
        "10-13": { 30: 234, 90: 193 },
        "14-17": { 30: 290, 90: 239 },
        "17+": { 30: 400, 90: 329 },
      },
    },
  };

  // const generatePDF = (data, vehicles, documentId) => {
  //     const pdf = new jsPDF({
  //         orientation: 'portrait',
  //         unit: 'pt',
  //         format: 'a4',
  //     });

  //     console.log(models)
  //     const nomComplet = data.lastName && data.firstName ? `${data.lastName} ${data.firstName}` : data.raisonSociale || '';
  //     const fullAddress = (data.street && data.city && data.country) ? `${data.street}, ${data.city}, ${data.country}` : '';

  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     let yPos = 80;

  //     // Titre centré et en gras
  //     pdf.setFontSize(18);
  //     pdf.setFont('helvetica', 'bold');
  //     pdf.text('RECAPITULATIF', pageWidth / 2, yPos, { align: 'center' });
  //     yPos += 30;

  //     // Informations du destinataire
  //     pdf.setFontSize(10);
  //     pdf.setFont('helvetica', 'bold');
  //     pdf.text(`Destinataire :`, 40, yPos);
  //     yPos += 15;

  //     pdf.setFont('helvetica', 'normal');
  //     pdf.text(nomComplet, 40, yPos);
  //     yPos += 15;

  //     pdf.text(fullAddress, 40, yPos);
  //     yPos += 15;

  //     pdf.text(`${data.phoneNumber || ''}`, 40, yPos);
  //     yPos += 30;

  //     // Détails de l'assurance
  //     pdf.setFont('helvetica', 'bold');
  //     pdf.text(`Produit d'assurance :`, pageWidth - 200, yPos, { align: 'right' });
  //     pdf.setFont('helvetica', 'normal');
  //     pdf.text('Assurance Frontière', pageWidth - 40, yPos, { align: 'right' });
  //     yPos += 15;

  //     pdf.setFont('helvetica', 'bold');
  //     pdf.text(`Référence :`, pageWidth - 200, yPos, { align: 'right' });
  //     pdf.setFont('helvetica', 'normal');
  //     pdf.text(`${documentId || ''}`, pageWidth - 40, yPos, { align: 'right' });
  //     yPos += 15;

  //     pdf.setFont('helvetica', 'bold');
  //     pdf.text(`Payable :`, pageWidth - 300, yPos, { align: 'right' });
  //     pdf.setFont('helvetica', 'normal');
  //     pdf.text('Dans les 10 jours ouvrés suivant l\'émission de la facture', pageWidth - 40, yPos, { align: 'right' });
  //     yPos += 60;

  //     // Titre de la section des véhicules
  //     pdf.setFontSize(14);
  //     pdf.setFont('helvetica', 'bold');
  //     pdf.text('LISTE DES VEHICULES', pageWidth / 2, yPos, { align: 'center' });
  //     yPos += 30;

  //     // En-tête du tableau
  //     pdf.setFontSize(9);
  //     pdf.setFont('helvetica', 'bold');
  //     const headers = ['Immatriculation', 'Marque', 'Modèle', 'Prix calculé', '1ère mise en circulation'];
  //     const cellWidths = [100, 80, 100, 80, 120];
  //     const tableWidth = cellWidths.reduce((acc, w) => acc + w, 0);
  //     const marginLeft = (pageWidth - tableWidth) / 2;
  //     let xPos = marginLeft;

  //     headers.forEach((header, index) => {
  //         pdf.text(header, xPos + cellWidths[index] / 2, yPos, { align: 'center' });
  //         pdf.rect(xPos, yPos - 12, cellWidths[index], 15, 'S'); // Bordure pour l'en-tête
  //         xPos += cellWidths[index];
  //     });
  //     yPos += 15;

  //     // Contenu du tableau
  //     pdf.setFont('helvetica', 'normal');
  //     vehicles.forEach((vehicle) => {
  //         xPos = marginLeft;
  //         const rowData = [
  //             vehicle.immat || '',
  //             vehicle.brand || '',
  //             vehicle.model || '',
  //             `${vehicle.price || ''} USD`,
  //             vehicle.firstRegistrationYear || ''
  //         ];
  //         rowData.forEach((data, index) => {
  //             pdf.text(data, xPos + cellWidths[index] / 2, yPos + 10, { align: 'center' });
  //             pdf.rect(xPos, yPos - 2, cellWidths[index], 15, 'S'); // Bordure de la cellule
  //             xPos += cellWidths[index];
  //         });
  //         yPos += 15;
  //     });

  //     // Calcul et affichage du prix total
  //     const totalPrice = vehicles.reduce((acc, vehicle) => acc + (vehicle.price || 0), 0);
  //     const ARCA = (totalPrice * 0.02).toFixed(2);
  //     const TVA = (totalPrice * 0.16).toFixed(2);
  //     const fraisService = (totalPrice * 0.19).toFixed(2);
  //     const finalPrice = (totalPrice + parseFloat(ARCA) + parseFloat(TVA) + parseFloat(fraisService)).toFixed(2);

  //     yPos += 35;
  //     pdf.setFont('helvetica', 'bold');
  //     pdf.text(`Prime nette USD :`, marginLeft, yPos);
  //     pdf.setFont('helvetica', 'normal');
  //     pdf.text(`${totalPrice} USD`, marginLeft + 150, yPos);
  //     yPos += 15;

  //     pdf.setFont('helvetica', 'bold');
  //     pdf.text(`Frais de contrôle ARCA (2%) :`, marginLeft, yPos);
  //     pdf.setFont('helvetica', 'normal');
  //     pdf.text(`${ARCA} USD`, marginLeft + 150, yPos);
  //     yPos += 15;

  //     pdf.setFont('helvetica', 'bold');
  //     pdf.text(`TVA (16%) :`, marginLeft, yPos);
  //     pdf.setFont('helvetica', 'normal');
  //     pdf.text(`${TVA} USD`, marginLeft + 150, yPos);
  //     yPos += 15;

  //     pdf.setFont('helvetica', 'bold');
  //     pdf.text(`Frais de service DIGIS (19%) :`, marginLeft, yPos);
  //     pdf.setFont('helvetica', 'normal');
  //     pdf.text(`${fraisService} USD`, marginLeft + 150, yPos);
  //     yPos += 15;

  //     pdf.setFont('helvetica', 'bold');
  //     pdf.text(`Prime brut USD :`, marginLeft, yPos);
  //     pdf.setFont('helvetica', 'normal');
  //     pdf.text(`${finalPrice} USD`, marginLeft + 150, yPos);
  //     yPos += 30;

  //     // Montant en lettres
  //     const montantLettres = toWords(finalPrice, { lang: 'fr' });
  //     pdf.setFont('helvetica', 'bold');
  //     pdf.text(`Montant en lettres :`, marginLeft, yPos);
  //     pdf.setFont('helvetica', 'normal');
  //     pdf.text(montantLettres, marginLeft + 150, yPos);
  //     yPos += 50;

  //     pdf.setFontSize(6);
  //     pdf.text('Payable par virement bancaire à : TRUST MERCHANT BANK S.A', marginLeft, yPos);
  //     yPos += 10;
  //     pdf.text(`DIGITAL INNOVATIVE SOLUTIONS SARL, société à responsabilité limitée au capital social de CDF 20.000.000`, marginLeft, yPos + 20);
  //     yPos += 10;
  //     pdf.text(`entièrement libéré, Siège : 372, Av. Colonel Mondjiba Kinshasa/Ngaliema–RDC,`, marginLeft, yPos + 20);
  //     yPos += 10;
  //     pdf.text(`RCCM : CD/KNG/RCCM/23-B-01880, N° ID. Nat. : 01-H5300-N36881G, N° Impôt : A2317655R,`, marginLeft, yPos + 20);
  //     yPos += 10;
  //     pdf.text(`Contact : contact@digis-assur.cd`, marginLeft, yPos + 20);

  //     pdf.save('facture_digis.pdf');
  // };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const brandDocs = await getDocs(collection(db, "brands"));
        const brandsList = brandDocs.docs.map((doc) => doc.id);
        const brandsModels = brandDocs.docs.reduce((acc, doc) => {
          acc[doc.id] = doc.data().models || []; // Associe les modèles à chaque marque
          return acc;
        }, {});
        setBrands(brandsList);
        setBrandModels(brandsModels); // Met à jour les modèles par marque

        console.log("Brands:", brandsList);
        console.log("Models:", brandsModels);

        const colorDocs = await getDocs(collection(db, "colors"));
        const colorsList = colorDocs.docs.map((doc) => doc.id);
        setColors(colorsList);
        console.log("Colors:", colorsList);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // Utilisez un useEffect pour mettre à jour les modèles en fonction de la marque sélectionnée
  useEffect(() => {
    if (selectedBrand) {
      setModels(brandModels[selectedBrand] || []); // Met à jour les modèles selon la marque sélectionnée
    } else {
      setModels([]); // Réinitialise les modèles si aucune marque n'est sélectionnée
    }
  }, [selectedBrand, brandModels]);

  const handleAddBrand = async () => {
    if (newBrand && !brands.includes(newBrand)) {
      try {
        const brandDocRef = doc(db, "brands", newBrand); // Référence avec l'ID personnalisé
        await setDoc(brandDocRef, { models: [] }); // Création du document avec un tableau models vide

        // Mettre à jour la liste des marques
        setBrands((prevBrands) => [...prevBrands, newBrand]);

        // Sélectionner automatiquement la nouvelle marque
        setSelectedBrand(newBrand);
        setValue("brand", newBrand); // Synchroniser avec react-hook-form

        // Réinitialiser l'input pour ajouter une nouvelle marque
        setNewBrand("");

        toast.success("La marque a été bien ajoutée");
      } catch (error) {
        toast.error("Une erreur s'est produite lors de l'ajout de la marque");
        console.error(error);
      }
    } else {
      toast.error("La marque que vous voulez ajouter existe déjà");
    }
  };

  const handleAddModel = async () => {
    if (newModel && !brandModels[selectedBrand]?.includes(newModel)) {
      // Référence au document de la marque sélectionnée
      const brandDocRef = doc(db, "brands", selectedBrand);

      // Mise à jour de l'array "models"
      await updateDoc(brandDocRef, {
        models: [...(brandModels[selectedBrand] || []), newModel],
      });

      // Met à jour l'état local
      setModels((prevModels) => [...prevModels, newModel]);
      setBrandModels((prevModels) => ({
        ...prevModels,
        [selectedBrand]: [...(prevModels[selectedBrand] || []), newModel],
      }));
      console.log(models);
      setNewModel("");
      setSelectedModel(newModel);
      toast.success("Le modèle a été bien ajouté");
    } else {
      toast.error("Le modèle que vous voulez ajouter existe déjà");
    }
  };

  const handleAddColor = async () => {
    if (newColor && !colors.includes(newColor)) {
      const colorDocRef = doc(db, "colors", newColor); // Référence avec l'ID personnalisé
      await setDoc(colorDocRef, {}); // Création du document sans champ "name"
      setColors([...colors, newColor]);
      setValue("carColor", newColor); // Définit la valeur dans React Hook Form
      // Réinitialise l'input de nouvelle couleur
      setNewColor("");
    }
  };

  function calculateInsurancePrice(
    selectedType,
    selectedUsage,
    selectedCylindree,
    selectedDuration,
    SelectedCards,
    selectedFiscalPower,
    selectedTonnage,
    selectedSeats,
    isDoublePedal,
    isInSale,
    selectedTrailers,
    selectedRealCardCount,
    selectedRealSeats
  ) {
    // Vérifiez si usage est défini
    if (!selectedUsage) {
      console.error("L'usage est non défini");
      return 0; // ou une autre valeur par défaut
    }

    // Récupérez les tarifs correspondant à l'utilisation sélectionnée
    const rates = insuranceRates[selectedType]?.[selectedUsage];
    if (!rates) {
      return "Tarif non trouvé par rapport au modèle";
    }

    console.log(
      "Type :",
      selectedType,
      "Usage :",
      selectedUsage,
      "Cylindrée :",
      selectedCylindree,
      "Durée :",
      selectedDuration,
      "Nombre de cartes :",
      SelectedCards,
      "Puissance fiscale :",
      selectedFiscalPower,
      "Tonnage :",
      selectedTonnage,
      "Nombre de places :",
      selectedSeats,
      "Double pédal ? :",
      isDoublePedal,
      "Remorques :",
      selectedTrailers,
      "En Vente :",
      isInSale,
      "Nombre de cartes réel :",
      selectedRealCardCount,
      "Nombre de place réel :",
      selectedRealSeats
    );

    switch (selectedType) {
      case "moto":
        // Conditions pour le type Moto
        switch (selectedUsage) {
          case "personnel":
            if (selectedCylindree && selectedDuration) {
              return (
                rates[selectedCylindree][selectedDuration] || "Tarif non trouvé"
              );
            }
            break;

          case "taxi":
            if (selectedDuration) {
              return rates[selectedDuration] || "Tarif non trouvé";
            }
            break;

          case "commerce":
            if (SelectedCards !== "more" && selectedDuration) {
              return (
                rates[SelectedCards][selectedDuration] || "Tarif non trouvé"
              );
            } else {
              if (SelectedCards === "more" && selectedDuration) {
                return (
                  rates[SelectedCards][selectedDuration] *
                    selectedRealCardCount || "Tarif non trouvé"
                );
              }
            }
            break;

          case "ecolage":
            if (selectedCylindree && selectedDuration) {
              return (
                rates[selectedCylindree][selectedDuration] || "Tarif non trouvé"
              );
            }
            break;

          default:
            return "Usage non reconnu";
        }
        break;

      case "voiture":
        // Conditions pour le type Voiture / Véhicule de tourisme
        switch (selectedUsage) {
          case "personnel":
            if (isInSale === "oui") {
              if (SelectedCards !== "more" && selectedDuration) {
                return (
                  rates[isInSale][SelectedCards][selectedDuration] ||
                  "Tarif non trouvé"
                );
              } else {
                if (SelectedCards === "more" && selectedDuration) {
                  return (
                    rates[isInSale][SelectedCards][selectedDuration] *
                      selectedRealCardCount || "Tarif non trouvé"
                  );
                }
              }
            } else {
              if (selectedFiscalPower && selectedDuration) {
                return (
                  rates[isInSale][selectedFiscalPower][selectedDuration] ||
                  "Tarif non trouvé"
                );
              }
            }
            break;

          case "transport_commun":
            if (isInSale === "oui") {
              if (SelectedCards !== "more" && selectedDuration) {
                return (
                  rates[isInSale][SelectedCards][selectedDuration] ||
                  "Tarif non trouvé"
                );
              } else {
                if (SelectedCards === "more" && selectedDuration) {
                  return (
                    rates[isInSale][SelectedCards][selectedDuration] *
                      selectedRealCardCount || "Tarif non trouvé"
                  );
                }
              }
            } else {
              if (selectedDuration) {
                return rates[isInSale][selectedDuration] || "Tarif non trouvé";
              }
            }
            break;

          case "taxi":
            if (selectedDuration === "90") {
              return rates[selectedDuration] || "Tarif non trouvé";
            }
            break;

          case "ecolage":
            if (isDoublePedal === "oui") {
              if (selectedFiscalPower && selectedDuration) {
                console.log(
                  isDoublePedal,
                  selectedFiscalPower,
                  selectedDuration
                );
                return (
                  rates[isDoublePedal][selectedFiscalPower][selectedDuration] ||
                  "Tarif non trouvé"
                );
              }
            } else {
              if (selectedFiscalPower && selectedDuration) {
                return (
                  rates[isDoublePedal][selectedFiscalPower][selectedDuration] ||
                  "Tarif non trouvé"
                );
              }
            }
            break;

          default:
            return "Usage non reconnu";
        }
        break;

      case "suv":
        // Conditions pour Jeep (SUV, 4x4)
        switch (selectedUsage) {
          case "personnel":
            if (isInSale === "oui") {
              if (SelectedCards !== "more" && selectedDuration) {
                return (
                  rates[isInSale][SelectedCards][selectedDuration] ||
                  "Tarif non trouvé"
                );
              } else {
                if (SelectedCards === "more" && selectedDuration) {
                  return (
                    rates[isInSale][SelectedCards][selectedDuration] *
                      selectedRealCardCount || "Tarif non trouvé"
                  );
                }
              }
            } else {
              if (selectedFiscalPower && selectedDuration) {
                return (
                  rates[isInSale][selectedFiscalPower][selectedDuration] ||
                  "Tarif non trouvé"
                );
              }
            }
            break;

          case "transport_commun":
            if (isInSale === "oui") {
              if (SelectedCards !== "more" && selectedDuration) {
                return (
                  rates[isInSale][SelectedCards][selectedDuration] ||
                  "Tarif non trouvé"
                );
              } else {
                if (SelectedCards === "more" && selectedDuration) {
                  return (
                    rates[isInSale][SelectedCards][selectedDuration] *
                      selectedRealCardCount || "Tarif non trouvé"
                  );
                }
              }
            } else {
              if (selectedDuration) {
                return rates[isInSale][selectedDuration] || "Tarif non trouvé";
              }
            }
            break;

          case "taxi":
            if (selectedDuration === "90") {
              return rates[selectedDuration] || "Tarif non trouvé";
            }
            break;

          case "ecolage":
            if (isDoublePedal === "oui") {
              if (selectedFiscalPower && selectedDuration) {
                return (
                  rates[isDoublePedal][selectedFiscalPower][selectedDuration] ||
                  "Tarif non trouvé"
                );
              }
            } else {
              if (selectedFiscalPower && selectedDuration) {
                return (
                  rates[isDoublePedal][selectedFiscalPower][selectedDuration] ||
                  "Tarif non trouvé"
                );
              }
            }
            break;

          case "location":
            if (selectedFiscalPower && selectedDuration) {
              return (
                rates[selectedFiscalPower][selectedDuration] ||
                "Tarif non trouvé"
              );
            }
            break;

          default:
            return "Usage non reconnu";
        }
        break;

      case "bus":
        // Conditions pour Bus
        switch (selectedUsage) {
          case "transport_commun":
            if (selectedSeats !== ">50" && selectedDuration) {
              return (
                rates[selectedSeats][selectedDuration] || "Tarif non trouvé"
              );
            } else {
              if (selectedSeats === ">50" && selectedDuration) {
                return (
                  rates[selectedSeats][selectedDuration] +
                    (selectedRealSeats - 50) * 5 || "Tarif non trouvé"
                );
              }
            }
            break;

          case "taxi":
            if (selectedSeats !== ">50" && selectedDuration) {
              return (
                rates[selectedSeats][selectedDuration] || "Tarif non trouvé"
              );
            } else {
              if (selectedSeats === ">50" && selectedDuration) {
                return (
                  rates[selectedSeats][selectedDuration] +
                    (selectedRealSeats - 50) * 5 || "Tarif non trouvé"
                );
              }
            }

            break;

          default:
            return "Usage non reconnu";
        }
        break;

      case "camion":
        // Conditions pour Camion
        switch (selectedUsage) {
          case "marchandises":
          case "marchandises_r":
            if (isInSale === "oui") {
              if (SelectedCards !== "more" && selectedDuration) {
                return (
                  rates[isInSale][SelectedCards][selectedDuration] ||
                  "Tarif non trouvé"
                );
              } else {
                if (SelectedCards === "more" && selectedDuration) {
                  return (
                    rates[isInSale][SelectedCards][selectedDuration] *
                      selectedRealCardCount || "Tarif non trouvé"
                  );
                }
              }
            } else {
              if (selectedTonnage && selectedDuration) {
                return (
                  rates[isInSale][selectedTonnage][selectedDuration] +
                    rates["supplement"][selectedTonnage][selectedDuration] *
                      selectedTrailers || "Tarif non trouvé"
                );
              }
            }
            break;

          case "ecolage":
            if (isDoublePedal && selectedTonnage && selectedDuration) {
              return (
                rates[isDoublePedal][selectedTonnage][selectedDuration] ||
                "Tarif non trouvé"
              );
            }
            break;

          case "location":
            if (selectedTonnage && selectedDuration) {
              return (
                rates[selectedTonnage][selectedDuration] +
                  rates["supp"][selectedDuration] * selectedTrailers ||
                "Tarif non trouvé"
              );
            }
            break;

          default:
            return "Usage non reconnu";
        }
        break;

      case "special":
        // Conditions pour Véhicule spécial
        switch (selectedUsage) {
          case "tracteurs":
          case "excavateurs":
          case "engins":
            if (selectedDuration) {
              return rates[selectedDuration] || "Tarif non trouvé";
            }
            break;

          case "citerne":
            if (selectedTrailers && selectedDuration === "90") {
              return (
                rates[selectedTrailers][selectedDuration] || "Tarif non trouvé"
              );
            }
            break;

          case "autres":
            if (selectedFiscalPower && selectedDuration) {
              return (
                rates[selectedFiscalPower][selectedDuration] ||
                "Tarif non trouvé"
              );
            }
            break;

          default:
            return "Usage non reconnu";
        }
        break;

      default:
        return "Type de véhicule non reconnu";
    }

    return "Tarif non trouvé";
  }

  const removeVehicle = (index) => {
    setVehicles(vehicles.filter((_, i) => i !== index));
  };

  const handleVehicleTypeChange = (type) => {
    setSelectedType(type);
    // Réinitialiser les états selon le type de véhicule sélectionné
    setSelectedUsage("");
    setSelectedFiscalPower("");
    setSelectedDuration("");
    setSelectedTonnage("");
    setSelectedSeats("");
    setIsInSale("");
  };
  const handleUsageChange = (usage) => {
    setSelectedUsage(usage);
    // Réinitialiser les états selon l'usage sélectionné
    setIsInSale("");
    setSelectedFiscalPower("");
    setSelectedDuration("");
    setSelectedTonnage("");
    setSelectedSeats("");
  };
  const fileInputRef = useRef(null);
  const handleReset = () => {
    setSelectedUsage("");
    setSelectedImmat("");
    setSelectedType("");
    setIsInSale("");
    setSelectedCylindree("");
    setSelectedFiscalPower("");
    setSelectedDuration("");
    setSelectedTonnage("");
    setSelectedSeats("");
    setSelectedRealSeats("");
    setIsDoublePedal("");
    setSelectedTrailers("");
    setSelectedCards("");
    setSelectedRealCardCount("");
    setSelectedBrand("");
    setSelectedModel("");
    setDocRef("");

    reset({
      cylindree: "",
      usage: "",
      duration: "",
      immat: "",
      vehicleType: "",
      fiscalPower: "",
      isInSale: "",
      numberOfCards: "",
      cards: "",
      isDoublePedal: "",
      seats: "",
      tonnage: "",
      realseats: "",
      trailers: "",
      brand: "",
      carColor: "",
      model: "",
      chassisNumber: "",
      manufactureYear: "",
      firstRegistrationYear: "",
      payload: "",
      otherspecial: "",
      document: "",
      startDate: watch("startDate"),
      category: watch("category"),
    });
  };

  // Gestion des changements de sélection
  const handleDurationChange = (duration) => setSelectedDuration(duration);
  const handleCylindreeChange = (cylindree) => setSelectedCylindree(cylindree);
  const handleIsInSaleChange = (isInSale) => setIsInSale(isInSale);
  const handleSelectedCardsChange = (SelectedCards) =>
    setSelectedCards(SelectedCards);
  const handleFiscalPowerChange = (fiscalPower) =>
    setSelectedFiscalPower(fiscalPower);

  const nextStep = async () => {
    const isValid = await trigger(); // Valide tous les champs actuels
    if (isValid) {
      setStep(step + 1);
    }
  };

  const nextStepWithSignature = async () => {
    if (signatureUrl) {
      setStep(step + 1);
    } else {
      // alert("Signature obligatoire !")
      setIsSignatureValid(false);
    }
  };

  const nextStepWithoutTrigger = async () => {
    setStep(step + 1);
  };

  const prevStep = () => setStep(step - 1);

  const onSubmit = (data) => {
    if (docRef) {
      console.log("Formulaire soumis :", data);
      const formattedData = {
        ...data,
        manufactureYear: data.manufactureYear
          ? new Date(data.manufactureYear).getFullYear().toString()
          : "",
        firstRegistrationYear: data.firstRegistrationYear
          ? new Date(data.firstRegistrationYear).getFullYear().toString()
          : "",
      };
      const price = calculateInsurancePrice(
        selectedType,
        selectedUsage,
        selectedCylindree,
        selectedDuration,
        SelectedCards,
        selectedFiscalPower,
        selectedTonnage,
        selectedSeats,
        isDoublePedal,
        isInSale,
        selectedTrailers,
        selectedRealCardCount,
        selectedRealSeats
      );
      const updatedData = { ...formattedData, price };
      setVehicles((prevVehicles) => {
        if (!Array.isArray(prevVehicles)) {
          prevVehicles = [];
        }
        return [...prevVehicles, updatedData];
      });

      handleReset();
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  let discount;
  let totalPrice;
  let TVA;
  let ARCA;
  let finalPrice;

  const getQuote = async () => {
    try {
      totalPrice = vehicles.reduce(
        (acc, vehicle) => acc + (vehicle.price || 0),
        0
      );

      discount = 0;
      const vehicleCount = vehicles.length;

      if (vehicleCount >= 5 && vehicleCount <= 20) {
        discount = 0.15;
      } else if (vehicleCount >= 21 && vehicleCount <= 35) {
        discount = 0.175;
      } else if (vehicleCount >= 36 && vehicleCount <= 50) {
        discount = 0.2;
      } else if (vehicleCount >= 51 && vehicleCount <= 100) {
        discount = 0.225;
      } else if (vehicleCount > 100) {
        discount = 0.25;
      }

      const discountedPrice = totalPrice * (1 - discount);
      TVA = discountedPrice * 1.16 - discountedPrice;
      ARCA = discountedPrice * 1.02 - discountedPrice;
      finalPrice = discountedPrice + TVA + ARCA;

      setTarifsBlock({
        discount,
        totalPrice,
        TVA,
        ARCA,
        finalPrice,
      });

      console.log(`Total véhicules : ${vehicleCount}`);
      console.log(`Prime avant réduction : ${totalPrice} $`);
      console.log(`Réduction appliquée : ${discount * 100}%`);
      console.log("Prime après réduction :", discountedPrice, "$");
      console.log("Montant TVA :", TVA, "$");
      console.log("Montant ARCA :", ARCA, "$");
      console.log("Prime finale avec TVA + ARCA :", finalPrice, "$");

      const vehicleReferences = [];
      const vehiclePromises = vehicles.map(async (vehicle) => {
        // Assurez-vous que toutes les valeurs sont définies
        const vehicleData = {
          cylindree: vehicle.cylindree || "", // Valeur par défaut
          usage: vehicle.usage || "",
          duration: vehicle.duration || "",
          immat: vehicle.immat || "",
          vehicleType: vehicle.vehicleType || "",
          fiscalPower: vehicle.fiscalPower || "",
          isInSale: vehicle.isInSale || false,
          numberOfCards: vehicle.numberOfCards || 0,
          cards: vehicle.cards || 0,
          document: vehicle.document || "",
          doublePedal: vehicle.isDoublePedal || false,
          seats: vehicle.seats || 0,
          tonnage: vehicle.tonnage || 0,
          realseats: vehicle.realseats || 0,
          trailers: vehicle.trailers || 0,
          price: vehicle.price || 0, // Assurez-vous que price a une valeur par défaut
          brand: vehicle.brand || "",
          color: vehicle.carColor || "",
          model: vehicle.model || "",
          chassisNumber: vehicle.chassisNumber || "",
          manufactureYear: vehicle.manufactureYear
            ? new Date(vehicle.manufactureYear).getFullYear()
            : "",
          firstRegistrationYear: vehicle.firstRegistrationYear
            ? new Date(vehicle.firstRegistrationYear).getFullYear()
            : "",
          payload: vehicle.payload || "",
          otherspecial: vehicle.otherspecial || "",
        };

        // Ajouter le véhicule à Firestore
        const vehicleDocRef = await addDoc(
          collection(db, "vehicles"),
          vehicleData
        );
        vehicleReferences.push(vehicleDocRef.id);
      });

      await Promise.all(vehiclePromises);

      console.log("Références des véhicules ajoutés :", vehicleReferences);

      const formWithVehicles = {
        vehicles: vehicleReferences,
        totalPrice: totalPrice,
        firstName: vehicles[0].firstName || "",
        lastName: vehicles[0].lastName || "",
        raisonSociale: vehicles[0].raisonSociale || "",
        email: vehicles[0].email,
        phoneNumber: vehicles[0].phoneNumber,
        secondaryPhoneNumber: vehicles[0].secondaryPhoneNumber || "",
        street: vehicles[0].street,
        city: vehicles[0].city,
        country: vehicles[0].country,
        startDate: vehicles[0].startDate,
        discountedPrice: discountedPrice,
        TVA: TVA,
        ARCA: ARCA,
        createdAt: new Date(),
        finalPrice: finalPrice,
        Agent: user.uid,
        paid: false,
      };

      const formDocRef = await addDoc(
        collection(db, "forms"),
        formWithVehicles
      );
      // const data = vehicles[0]

      console.log(
        "Formulaire ajouté avec succès, ID du document :",
        formDocRef.id
      );
      // firstVehicle = data;
      nextStepWithoutTrigger();
      setFormDocId(formDocRef.id);
      // generatePDF(data, vehicles, formDocRef.id)
    } catch (error) {
      console.error("Erreur lors de la soumission du devis :", error);
    }
  };

  const getUsagesForType = (vehicleType) => {
    switch (vehicleType) {
      case "moto":
        return [
          { value: "personnel", label: "Personnel" },
          { value: "taxi", label: "Taxi" },
          { value: "ecolage", label: "Ecolage" },
          { value: "commerce", label: "Vente/Réparation/Essai" },
        ];
      case "voiture":
        return [
          { value: "personnel", label: "Personnel" },
          { value: "taxi", label: "Taxi" },
          { value: "transport_commun", label: "Transport en commun" },
          { value: "location", label: "Location" },
          { value: "ecolage", label: "Ecolage" },
        ];
      case "suv":
        return [
          { value: "personnel", label: "Personnel" },
          { value: "taxi", label: "Taxi" },
          { value: "transport_commun", label: "Transport en commun" },
          { value: "location", label: "Location" },
          { value: "ecolage", label: "Ecolage" },
        ];
      case "bus":
        return [
          { value: "transport_commun", label: "Transport en commun" },
          { value: "taxi", label: "Taxi" },
        ];
      case "camion":
        return [
          { value: "marchandises", label: "Marchandises" },
          { value: "marchandises_r", label: "Marchandises rémunérées" },
          { value: "ecolage", label: "Ecolage" },
          { value: "location", label: "Location" },
        ];
      case "special":
        return [
          { value: "tracteurs", label: "Tracteurs agricoles" },
          { value: "excavateurs", label: "Excavateurs et élévateurs" },
          { value: "engins", label: "Engins et grues" },
          { value: "citerne", label: "Camion citerne" },
          { value: "autres", label: "Autres" },
        ];
      default:
        return [];
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {step === 1 && (
        <>
          {/*Informations de l'assuré*/}
          <Step1
            register={register}
            errors={errors}
            personType={personType}
            setPersonType={setPersonType}
            navigate={navigate}
            nextStep={nextStep}
            setValue={setValue}
          />
        </>
      )}

      {step === 2 && (
        <>
          {/* 2ème étape : Date d'effet du contrat */}
          <Step2
            register={register}
            errors={errors}
            prevStep={prevStep}
            nextStep={nextStep}
          />
        </>
      )}

      {step === 3 && (
        <>
          {/* 3ème étape : Informations sur le véhicule */}
          <Step3
            register={register}
            errors={errors}
            watch={watch}
            selectedImmat={selectedImmat}
            setSelectedImmat={setSelectedImmat}
            selectedBrand={selectedBrand}
            setSelectedBrand={setSelectedBrand}
            brands={brands}
            newBrand={newBrand}
            setNewBrand={setNewBrand}
            handleAddBrand={handleAddBrand}
            selectedModel={selectedModel}
            setSelectedModel={setSelectedModel}
            brandModels={brandModels}
            newModel={newModel}
            setNewModel={setNewModel}
            handleAddModel={handleAddModel}
            colors={colors}
            newColor={newColor}
            setNewColor={setNewColor}
            handleAddColor={handleAddColor}
            selectedType={selectedType}
            handleVehicleTypeChange={handleVehicleTypeChange}
            selectedUsage={selectedUsage}
            handleUsageChange={handleUsageChange}
            getUsagesForType={getUsagesForType}
            selectedCylindree={selectedCylindree}
            selectedDuration={selectedDuration}
            SelectedCards={SelectedCards}
            selectedRealCardCount={selectedRealCardCount}
            handleCylindreeChange={handleCylindreeChange}
            handleDurationChange={handleDurationChange}
            handleSelectedCardsChange={handleSelectedCardsChange}
            setSelectedRealCardCount={setSelectedRealCardCount}
            isInSale={isInSale}
            handleIsInSaleChange={handleIsInSaleChange}
            selectedFiscalPower={selectedFiscalPower}
            handleFiscalPowerChange={handleFiscalPowerChange}
            isDoublePedal={isDoublePedal}
            setIsDoublePedal={setIsDoublePedal}
            setIsInSale={setIsInSale}
            setSelectedDuration={setSelectedDuration}
            setSelectedFiscalPower={setSelectedFiscalPower}
            selectedSeats={selectedSeats}
            setSelectedSeats={setSelectedSeats}
            selectedRealSeats={selectedRealSeats}
            setSelectedRealSeats={setSelectedRealSeats}
            selectedTonnage={selectedTonnage}
            setSelectedTonnage={setSelectedTonnage}
            selectedTrailers={selectedTrailers}
            setSelectedTrailers={setSelectedTrailers}
            setSelectedCards={setSelectedCards}
            otherVehicle={otherVehicle}
            setOtherVehicle={setOtherVehicle}
            setValue={setValue}
            fileInputRef={fileInputRef}
            setDocRef={setDocRef}
            docRef={docRef}
          />

          <div
            className="mt-[20px]"
            style={{ display: "flex", flexDirection: "row", gap: 30 }}
          >
            <PrimaryButton label={"Précédent"} onClick={prevStep} />
            <PrimaryButton label={"Ajouter un véhicule"} />
          </div>
          {vehicles.length > 0 ? (
            <SubmitButton type="button" onClick={getQuote} label={"Envoyer"} />
          ) : (
            <></>
          )}
          {vehicles.length > 0 ? (
            <p>Nombre total de véhicules à assurer : {vehicles.length}</p>
          ) : (
            <></>
          )}
          {vehicles.length > 0 ? (
            vehicles.map((vehicle, index) => (
              <div
                key={index}
                className="p-4 mb-4 border border-gray-300 rounded-lg shadow-lg bg-white"
              >
                <h5 className="text-lg font-semibold">Véhicule {index + 1}</h5>
                <p>
                  <strong>Immatriculation :</strong> {vehicle.immat}
                </p>
                <p>
                  <strong>Type de véhicule :</strong> {vehicle.vehicleType}
                </p>
                <p>
                  <strong>Usage :</strong>{" "}
                  {vehicle.usage === "autres"
                    ? vehicle.otherspecial
                    : vehicle.usage}
                </p>
                <button
                  className="bg-red-500 text-white px-3 py-1 rounded mt-2"
                  onClick={() => removeVehicle(index)}
                >
                  Supprimer ce véhicule
                </button>
              </div>
            ))
          ) : (
            <p>Aucun véhicule ajouté pour le moment.</p>
          )}
        </>
      )}

      {step === 4 && (
        <>
          <Step4
            vehicles={vehicles}
            firstVehicle={firstVehicle ? firstVehicle : vehicles[0]}
            tarifsBlock={tarifsBlock}
            onBack={prevStep}
            onSubmit={nextStepWithSignature}
            setValue={setValue}
            documentId={formdocId}
            setSignatureURL={setSignatureURL}
            signatureUrl={signatureUrl}
            setSignatureImage={setSignatureImage}
            isSignatureValid={isSignatureValid}
            setIsSignatureValid={setIsSignatureValid}
          />
        </>
      )}

      {step === 5 && (
        <>
          <Step5
            onPaymentMethodSelect={nextStep}
            setIsCardPayment={setIsCardPayment}
            onBack={prevStep}
          />
        </>
      )}

      {step === 6 && isCardPayment === false && (
        <>
          <Step6
            firstVehicle={firstVehicle}
            onOtpSubmit={nextStep}
            onBack={prevStep}
          />
        </>
      )}

      {step === 6 && isCardPayment === true && (
        <>
          <Step6bis
            firstVehicle={vehicles[0]}
            vehicles={vehicles}
            formdocId={formdocId}
            tarifsBlock={tarifsBlock}
            signature={signatureUrl}
            signatureImage={signatureImage}
            onBack={prevStep}
          />
        </>
      )}
    </form>
  );
};

export default MultiStepForm;
